import React from 'react';
import MALE_ICON from '../../../assets/images/male.png';
import FEMALE_ICON from '../../../assets/images/female.png';
import { PropTypes } from 'prop-types';
export default function Gender(props) {
    return (
        <img
            src={props?.gender === 'F' ? FEMALE_ICON : MALE_ICON}
            height={props.height ? props.height : '25'}
            alt={props?.gender === 'F' ? 'female' : 'male'}
        />
    );
}
Gender.propTypes = {
    gender: PropTypes.string,
    height: PropTypes.string
};
